import { toast } from "react-toastify"
import intl from "../../i18n/intl"

import { getCV, getCvs } from "../cv"
import { getJobs, getJobDetail } from "../jobs"

import { setCvs, updatePagination } from "../../redux/slices/cvSlice"
import { setJobs } from "../../redux/slices/jobSlice"

const { formatMessage } = intl()

export const fetchCVById = async (id, callback = () => {}, onErrorCallback = () => {}) =>
  getCV(id)
    .then((cv) => {
      callback(cv);
      return cv;
    })
    .catch((error) => {
      onErrorCallback(error);
      toast.error(formatMessage({ id: "toast.unableToFetchCV" }));
      return null;
    });

export const fetchCvs = async (dispatch, callback = () => {}, limit, offset) => {
  const response = await getCvs(limit, offset)
    .then((response) => {
      callback(response.cvs);
      
      dispatch(setCvs(response.cvs));
      dispatch(updatePagination({
        total: response.total,
        hasMore: response.hasMore
      }));
      
      return response.cvs;
    })
    .catch(() => {
      toast.error(formatMessage({ id: "toast.fetchCVsFail" }));
      return [];
    });
  return response;
};

export const fetchJobs = async (dispatch, callback = () => {}) =>
  getJobs()
    .then((jobs) => {
      callback(jobs);
      dispatch(setJobs(jobs));
      return jobs;
    })
    .catch(() => {
      toast.error(formatMessage({ id: "toast.fetchJobsFail" }));
      return [];
    });

export const fetchJobById = async (id, callback = () => {}) =>
  getJobDetail(id)
    .then((job) => {
      callback(job);
      return job;
    });
